import { ReactNode, useState } from 'react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@design-system';
import { ChevronRight } from 'lucide-react';

interface CollapsibleSectionProps {
  title: string;
  subtitle?: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
}

export function CollapsibleSection({
  title,
  subtitle,
  defaultOpen = true,
  children,
}: CollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Collapsible open={open} onOpenChange={setOpen} className="rounded-lg border border-gray-200">
      <CollapsibleTrigger className="flex w-full items-center justify-between px-4 py-3 hover:bg-gray-50">
        <span className="flex items-center gap-2 text-left">
          <ChevronRight
            className={`h-4 w-4 text-gray-500 transition-transform ${open ? 'rotate-90' : ''}`}
          />
          <span className="font-medium text-gray-900">{title}</span>
          {subtitle && <span className="text-sm text-gray-500">{subtitle}</span>}
        </span>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="border-t border-gray-200 p-4">{children}</div>
      </CollapsibleContent>
    </Collapsible>
  );
}
